/**
 * License Details Mock Data
 * Contains dummy data for individual license details
 * This data will be replaced with real API responses when backend is ready
 */

import type { LicenseDetail } from '../components/Dashboard/LicenseDetailsPanel/type';

const LICENSE_DETAILS_MOCK_DATA: Record<string, LicenseDetail | undefined> = {
  '1': {
    id: '1',
    vendor: 'SAP',
    logo: 'SAP',
    totalSpend: '$4.4M',
    spendTrend: '+3.6%',
    spendTrendDirection: 'up',
    utilization: '81%',
    utilizationTrend: '+2.7%',
    utilizationTrendDirection: 'up',
    costPerEmployee: '$2,874',
    costTrend: '+3.2%',
    costTrendDirection: 'up',
    optimizationScore: '83%',
    optimizationTrend: '-1.2%',
    optimizationTrendDirection: 'down',
    riskAlerts: '1',
    riskLevel: '1 Medium',
    sku: 'SAP-RISE-FUE',
    renewalDate: 'Exp Date 04/22/2025',
    userRoles: ['310 Managers', '1000 Users', '220 Developers'],
    licenseCost: 'Total Annual Cost: $4.4M',
    usage: '1215/1,530',
    usagePercentage: 79,
    status: 'Active',
    findings:
      'You can save $144,000 on your renewal by adjusting role classifications. I can build a report and share with you.',
  },
  '2': {
    id: '2',
    vendor: 'Office 365',
    logo: 'Office 365',
    totalSpend: '$2.8M',
    spendTrend: '+1.2%',
    spendTrendDirection: 'up',
    utilization: '74%',
    utilizationTrend: '+4.1%',
    utilizationTrendDirection: 'up',
    costPerEmployee: '$1,245',
    costTrend: '+0.8%',
    costTrendDirection: 'up',
    optimizationScore: '76%',
    optimizationTrend: '+2.3%',
    optimizationTrendDirection: 'up',
    riskAlerts: '0',
    riskLevel: 'No Risk',
    sku: 'O365-E5-2026',
    renewalDate: 'Exp Date 06/15/2026',
    userRoles: ['2500 Users', '450 Admins', '150 Developers'],
    licenseCost: 'Total Annual Cost: $2.8M',
    usage: '2250/3000',
    usagePercentage: 75,
    status: 'Active',
    findings:
      'Consider downgrading some users from E5 to E3 licenses to reduce costs by approximately $320,000 annually.',
  },
  '3': {
    id: '3',
    vendor: 'AWS',
    logo: 'AWS',
    totalSpend: '$3.2M',
    spendTrend: '+5.8%',
    spendTrendDirection: 'up',
    utilization: '68%',
    utilizationTrend: '-1.5%',
    utilizationTrendDirection: 'down',
    costPerEmployee: '$1,856',
    costTrend: '+5.2%',
    costTrendDirection: 'up',
    optimizationScore: '62%',
    optimizationTrend: '-3.1%',
    optimizationTrendDirection: 'down',
    riskAlerts: '2',
    riskLevel: '2 High',
    sku: 'AWS-ENTERPRISE-2026',
    renewalDate: 'Exp Date 03/10/2026',
    userRoles: ['180 Developers', '45 DevOps', '25 Architects'],
    licenseCost: 'Total Annual Cost: $3.2M',
    usage: '850/1250',
    usagePercentage: 68,
    status: 'Active',
    findings:
      'Reserved instances could save you $480,000 annually. We recommend committing to 1-year or 3-year plans for predictable workloads.',
  },
};

export default LICENSE_DETAILS_MOCK_DATA;
